<template>
    <!-- SCHEDULE DETAILS -->
    <div class="call-to-schedule" v-if="contactPhone">
        <p><b>Please Call to Schedule<br/><span v-if="locations.length">or try another location</span></b></p>
        <a :href="`tel:${ contactPhone }`" class="btn-primary">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.25 12.3027L13.2032 10.4886L13.1877 10.4817C12.9247 10.3683 12.6374 10.3227 12.3522 10.3489C12.0669 10.3752 11.7928 10.4726 11.5549 10.6321C11.5216 10.6544 11.4894 10.6785 11.4587 10.7043L9.54141 12.3371C8.42422 11.7313 7.27008 10.5866 6.66336 9.48314L8.30133 7.53579C8.32766 7.50436 8.35206 7.47136 8.37438 7.43697C8.52974 7.19991 8.62406 6.92812 8.64895 6.64578C8.67384 6.36345 8.62852 6.07934 8.51704 5.81876C8.51439 5.81377 8.51209 5.8086 8.51016 5.80329L6.69688 1.74962C6.54804 1.41062 6.29401 1.12854 5.97239 0.945135C5.65077 0.761729 5.27865 0.686739 4.9111 0.731263C3.66361 0.89514 2.51842 1.50751 1.68942 2.45401C0.860424 3.40051 0.404306 4.61641 0.406256 5.87462C0.406256 12.888 6.11165 18.5934 13.125 18.5934C14.3832 18.5953 15.5991 18.1392 16.5456 17.3102C17.4921 16.4812 18.1045 15.336 18.2684 14.0885C18.3129 13.721 18.2379 13.3489 18.0545 13.0272C17.8711 12.7056 17.589 12.4516 17.25 12.3027ZM13.125 16.5309C10.2998 16.5275 7.59136 15.4037 5.59367 13.406C3.59597 11.4083 2.47217 8.69979 2.46876 5.87462C2.46679 5.16263 2.70851 4.47139 3.15375 3.91578C3.59899 3.36017 4.22094 2.97363 4.91626 2.8204L6.5336 6.42978L4.88704 8.39087C4.86042 8.42259 4.83574 8.45588 4.81313 8.49056C4.65084 8.73854 4.55542 9.02426 4.53615 9.32C4.51687 9.61573 4.5744 9.91143 4.70313 10.1784C5.51266 11.8352 7.18071 13.4921 8.85477 14.3034C9.1235 14.4308 9.42068 14.4863 9.71727 14.4644C10.0139 14.4426 10.2997 14.3442 10.5469 14.1788C10.5801 14.1563 10.612 14.132 10.6423 14.1057L12.5698 12.4669L16.1792 14.0834C16.026 14.7787 15.6395 15.4006 15.0838 15.8459C14.5282 16.2911 13.837 16.5328 13.125 16.5309Z" fill="white"/>
            </svg>
            {{ contactPhone }}
        </a>
    </div>
</template>

<script>
export default {
    name: "ScheduleCall",
    data: () => {
        return {
        };
    },
    props: {
        locations: Array,
        phone: String
    },
    computed: {
        contactPhone: function(){
            return this.phone ? this.phone : '877-465-1856';
        }
    },
    methods: {

    },
    mounted() {},
    updated() {
    },
    components: {
    }
};
</script>  